import React, {useState, useEffect} from 'react'
import Loading from '../../../common/Loading'
import {toast} from 'react-toastify'
import settingsService from '../../../../services/settings.service'
import { useEyeconxStore } from '../../../../store/eyeconxStore'

function ClinicUser() {
  const [isLoading,setIsLoading] = useState(false)
  const [clinicUserInfo,setClinicUserInfo] = useState(null)
  const clinicId = useEyeconxStore(state => state.user.clinicId)

    useEffect(()=>{
         getClinicUsers()
    },[clinicId])

    const getClinicUsers = ()=>{
        setIsLoading(true)
        settingsService.getUsers(clinicId)
        .then(res=>{
            setClinicUserInfo(res.data)
            setIsLoading(false)
        })
        .catch(err=>{
            console.log("Error while getting Clinic Info")
            setIsLoading(false)
        })

    }
  
  return (
     <>
        <div className="row mb-4">
            <div className="col-12">
                <div className="d-flex justify-content-between">
                    <h1>Users</h1>
                   
                    
                </div>
            </div>
        </div>
        <div className="separator border-2 my-5"></div>
        {isLoading?<Loading/> : <>
            <div className="row">
                <div className="col-12">
                    <div className="table-responsive">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th> <span className="fw-semibold text-muted">Name</span></th>
                                    <th><span className="fw-semibold text-muted">User Name</span></th>
                                    <th><span className="fw-semibold text-muted">Role</span></th>
                                    <th><span className="fw-semibold text-muted">Authenticated</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                {clinicUserInfo && clinicUserInfo.map((user,index)=>{
                                    return (
                                        <tr key={index}>
                                            <td>
                                                <div className="d-flex flex-column">
                                                   <span className="fw-bold fs-6 text-gray-800">{user.firstName} {user.lastName}</span>
                                                    <span className="fs-6 text-gray-800">{user.email}</span>
                                                  
                                                </div>

                                            </td>
                                            <td>{user.userName}</td>
                                            <td>{user.roleName}</td>
                                            <td>
                                              {user.isAuthenticated >0 ? "Yes" : "No"}
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                        <div>
                        <span className='fw-bold text-gray-600'>  Note: To add new user or authenticate a user please contact Eyeconx.</span>
                        </div>
                    </div>
                </div>
            </div>
        </>}
     </>
  )
}

export default ClinicUser